let defaultButtons = [
  {
    classes: ['btn', 'btn-default'],
    type: 'default',
    style: {color: '#000'},
    background: {
      color: '#CCC'
    }
  },
  {
    classes: ['btn', 'btn-primary'],
    type: 'primary',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  },
  {
    classes: ['btn', 'btn-success'],
    type: 'success',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  },
  {
    classes: ['btn', 'btn-info'],
    type: 'info',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  },
  {
    classes: ['btn', 'btn-warning'],
    type: 'warning',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  },
  {
    classes: ['btn', 'btn-danger'],
    type: 'danger',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  },
  {
    classes: ['btn', 'btn-extra'],
    type: 'extra',
    style: {color: '#FFF'},
    background: {
      color: '#445073'
    }
  },
  {
    classes: ['btn', 'btn-extra-2'],
    type: 'extra 2',
    style: {color: '#FFF'},
    background: {
      color: '#87AE73'
    }
  }
];

export default defaultButtons;
